import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import {AuthProvider} from './contexts/AuthContext';
import {CreditsProvider} from './contexts/CreditsContext';
import {ApiKeyProvider} from './contexts/ApiKeyContext';
import AppLayout from 'layouts/AppLayout';
import FullScreenLayout from 'layouts/FullScreenLayout';
import LogInSignUp from 'application/pages/LogInSignUp';
import './index.css';

function App() {
    return (
		<AuthProvider>
			<CreditsProvider>
				<ApiKeyProvider>
				<Router>
					<Switch>

					{/* FULL SCREEN LAYOUTS */}
						<Route path = "/loginsignup">
							<FullScreenLayout>
								<LogInSignUp />
							</FullScreenLayout>
						</Route>

					{/* LAYOUTS WITH NAVBAR */}
						<Route>
							<AppLayout/>
						</Route>
					</Switch>
				</Router>
				</ApiKeyProvider>
			</CreditsProvider>
		</AuthProvider>
    );
}

export default App;
